export enum RequestStatus {
  notStarted = 'NOT_STARTED',
  loading = 'LOADING',
  success = 'SUCCESS',
  error = 'ERROR',
}
